module.exports = __webpack_public_path__ + "img/orange-btn.1a87885.gif";